import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  Slide
} from "@material-ui/core";
import withWidth, { isWidthDown } from "@material-ui/core/withWidth";
import { withNotificationContext } from "js/notification-context";
import ImageUploader, { ItemImages } from "js/components/Shared/ImageUploader";
import Grid from "@material-ui/core/Grid";
import SplashScreen from "js/pages/Loading";
import { addImageURL } from "js/constants";
import { getUrl } from "js/utils";
import { getSize } from "./utils";

const styles = theme => ({
  dialogPaperScroll: {
    // On small screens the modal uses fullScreen; the body scrolls so the
    // user can reach Cancelar/Aceptar without the dialog pushing them off
    // screen when an image is loaded.
    [theme.breakpoints.down("sm")]: {
      overflowY: "auto"
    }
  },
  dialogContent: {
    // Constrain the dialog body so vertical/portrait image previews cannot
    // push the action buttons below the modal viewport on any screen size.
    maxWidth: "100%",
    overflowY: "auto"
  }
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}
class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // nombre: this.props.grupoSKU ? this.props.grupoSKU.nombre : "",
      file: null,
      isLoadingImage: false,
      facturaImages: [],
      error: undefined,
      idPrograma: this.props.match.params.id,
      idUsuario: parseInt(localStorage.getItem("idUsuario"))
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setFacturaImages(({ facturaImages }) => {
        const pendingImages = facturaImages.filter(
          image => image.status !== "success"
        );
        const acceptedImages = (this.props.imageUrls || []).map(url => ({
          id: url,
          url,
          status: "success"
        }));

        return acceptedImages.concat(pendingImages);
      });
    }
  }

  setFacturaImages = (updater, callback) => {
    this.setState(
      previousState => {
        const facturaImages =
          typeof updater === "function" ? updater(previousState) : updater;
        return {
          facturaImages,
          isLoadingImage: facturaImages.some(
            image => image.status === "uploading"
          )
        };
      },
      () => {
        this.notifyUploadState();
        if (callback) callback();
      }
    );
  };

  notifyUploadState = () => {
    const { facturaImages } = this.state;
    this.props.onUploadStateChange({
      isLoading: facturaImages.some(image => image.status === "uploading"),
      hasError: facturaImages.some(image => image.status === "error")
    });
  };

  sendValues = async openModalFunction => {
    const { facturaImages } = this.state;

    if (facturaImages.length === 0) {
      const mensaje = "Debe seleccionar una imagen.";
      return this.props.openNotification(mensaje);
    }

    if (facturaImages.some(image => image.status === "uploading")) {
      return this.props.openNotification(
        "Hay imágenes cargándose. Espere a que finalice la carga antes de continuar."
      );
    }

    if (facturaImages.some(image => image.status === "error")) {
      return this.props.openNotification(
        "Hay imágenes que no se pudieron cargar. Reintentá o eliminá las imágenes fallidas."
      );
    }

    this.props.getUrlFacturaImagen(
      facturaImages
        .filter(image => image.status === "success")
        .map(image => image.url)
    );
    return openModalFunction(false);
  };

  onChangeImage = images => {
    const files = Array.isArray(images) ? images : [images];
    const available = this.getAvailableSlots();
    files.slice(0, available).forEach(image => this.uploadImage(image));
    if (files.length > available) {
      this.props.openNotification(
        `Puede cargar hasta ${this.props.maxImagenesCargaFactura} imágenes.`
      );
    }
  };

  getAvailableSlots = () =>
    Math.max(
      0,
      this.props.remainingImageSlots -
        this.state.facturaImages.filter(
          image =>
            image.status !== "success" ||
            !(this.props.imageUrls || []).includes(image.url)
        ).length
    );

  getMaxImages = () =>
    typeof this.props.maxImagenesCargaFactura === "number"
      ? this.props.maxImagenesCargaFactura
      : 1;

  uploadImage = async (image, retryImageId) => {
    const imageId = retryImageId || `${Date.now()}-${Math.random()}`;
    const pendingImage = { id: imageId, file: image, status: "uploading" };
    this.setFacturaImages(({ facturaImages }) => {
      const previousImage = facturaImages.find(
        current => current.id === imageId
      );
      return previousImage
        ? facturaImages.map(
            current => (current.id === imageId ? pendingImage : current)
          )
        : facturaImages.concat(pendingImage);
    });

    try {
      const { height, width } = await getSize(image);

      // Creamos un elemento de imagen para cargar la imagen
      const imgElement = new Image();

      imgElement.onload = () => {
        // Creamos un canvas para convertir la imagen a formato jpeg
        const canvas = document.createElement("canvas");
        canvas.width = imgElement.width;
        canvas.height = imgElement.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(imgElement, 0, 0);

        // Convertimos el canvas a formato jpeg
        canvas.toBlob(blob => {
          // Creamos un nuevo archivo Blob con el formato jpeg
          const jpegFile = new File([blob], image.name, { type: "image/jpeg" });

          // Creamos el FormData con el archivo jpeg
          const formData = new FormData();
          formData.append("image", jpegFile);
          formData.append("context", "cargaFactura");
          formData.append("height", height);
          formData.append("width", width);

          fetch(addImageURL, {
            method: "POST",
            credentials: "include",
            body: formData
          })
            .then(response => response.json())
            .then(({ url }) => {
              const imageUrl = getUrl(url);
              if (!imageUrl) {
                throw new Error("La URL de la imagen no es válida.");
              }
              this.setFacturaImages(({ facturaImages }) =>
                facturaImages.map(
                  current =>
                    current.id === imageId
                      ? { ...current, url: imageUrl, status: "success" }
                      : current
                )
              );
            })
            .catch(error => {
              console.error("Error al cargar la imagen:", error);
              this.setFacturaImages(({ facturaImages }) =>
                facturaImages.map(
                  current =>
                    current.id === imageId
                      ? { ...current, status: "error", error: error.message }
                      : current
                )
              );
              this.props.openNotification(
                error.message || "Hubo un error al cargar la imagen."
              );
            });
        }, "image/jpeg");
      };

      imgElement.src = URL.createObjectURL(image);
    } catch (error) {
      this.setFacturaImages(({ facturaImages }) =>
        facturaImages.map(
          current =>
            current.id === imageId ? { ...current, status: "error" } : current
        )
      );
    }
  };

  onRetryImage = image => {
    this.uploadImage(image.file, image.id);
  };

  onRemoveImage = image => {
    this.setFacturaImages(
      ({ facturaImages }) =>
        facturaImages.filter(current => current.id !== image.id),
      () => {
        this.props.getUrlFacturaImagen(
          this.state.facturaImages
            .filter(current => current.status === "success")
            .map(current => current.url),
          true
        );
      }
    );
  };

  render() {
    const { classes, open, openModalFunction, width } = this.props;

    const { facturaImages } = this.state;

    // On mobile (xs/sm) the dialog uses fullScreen so it always covers the
    // viewport; Cancelar/Aceptar remain reachable via internal scroll.
    // On md+ we constrain the width to a sensible modal size.
    const isMobile = isWidthDown("sm", width);

    return (
      <Fragment>
        <Dialog
          open={typeof open === "undefined" ? true : open}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          fullScreen={isMobile}
          fullWidth={!isMobile}
          maxWidth={isMobile ? false : "sm"}
          PaperProps={{ className: classes.dialogPaperScroll }}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle
            id="alert-dialog-slide-title"
            className={classes.dialogTitle}
          >
            <Grid item xs={12}>
              <ImageUploader
                onChangeImage={this.onChangeImage}
                disableClick={true}
                allowMultiple={true}
                disabled={this.getAvailableSlots() === 0}
                // medidasRecomendadas={"556 x 314"}
                withRecomendations={false}
              >
                <ItemImages
                  images={facturaImages}
                  onRemoveImage={this.onRemoveImage}
                  onRetry={this.onRetryImage}
                  disabled={false}
                  alt={"imagen-factura"}
                />
              </ImageUploader>
            </Grid>
          </DialogTitle>
          {this.state.isLoadingImage ? (
            <>
              <Grid container item style={{ height: 100 }}>
                <SplashScreen className={classes.progress} />
              </Grid>
            </>
          ) : null}
          <DialogActions>
            <Button
              onClick={() => openModalFunction(false)}
              variant="outlined"
              color="primary"
            >
              Cancelar
            </Button>
            <Button
              onClick={() => this.sendValues(openModalFunction)}
              variant="contained"
              color="primary"
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const enhance = compose(
  withApollo,
  withNotificationContext,
  withRouter,
  withStyles(styles),
  withWidth()
);

export default enhance(connect(null)(Modal));
